// Tuning constants for the 3D Scene. Kept in one place so the camera
// framing and fog density can be unit-tested without spinning up the
// Three.js renderer. (Audit 2026-07-16 visual finding — exp2 fog with
// density 0.0015 at 22-unit camera distance absorbs ~50% of color and
// the map reads as a black void.)

export const COMBAT_NEAR_RADIUS = 6;

// Sky, sea and haze (Environment.tsx). The fog is the horizon haze: light,
// so distance reads as atmosphere (the old near-black fog read as a void),
// and dense enough that the open sea melts into the sky at the horizon
// while the playable map (within ~30 units) stays clear.
export const SKY_ZENITH = '#2c4d78';
export const SKY_HORIZON = '#a9bfcf';
export const FOG_COLOR = '#9db4c6';
export const FOG_DENSITY = 0.012;
/** Deep water — the open sea and deep-ocean tiles share it, so the map edge is seamless. */
export const SEA_COLOR = '#1d4a6d';

// Three-quarter view: ~33° above the horizon at ~15.5 units, so the opening
// shot reads as a landscape (tree silhouettes, relief) rather than a flat
// top-down overview. Was 16/16 (45°, ~22.6 units) — zoomed out and steep.
export const CAMERA_Y = 8.5;
export const CAMERA_BACK_OFFSET = 13;
export const CAMERA_FOV = 45;

/** Camera elevation above the horizon, in degrees. */
export function cameraElevationDeg(): number {
  return (Math.atan2(CAMERA_Y, CAMERA_BACK_OFFSET) * 180) / Math.PI;
}

/** Camera distance from its focus point. */
export function cameraDistance(): number {
  return Math.hypot(CAMERA_Y, CAMERA_BACK_OFFSET);
}

export function getCameraPosition(
  center: readonly [number, number, number],
): [number, number, number] {
  return [center[0], CAMERA_Y, center[2] + CAMERA_BACK_OFFSET];
}
